import Form from "react-bootstrap/Form";
import Fuse from "fuse.js";

export default function CustomSearchbar({
  searchFlags = [],
  dataListTemp = [],
  stateUpdator = () => {},
  placeholders = [],
}) {
  const handleSearchBarAction = (e) => {
    try {
      const fuse = new Fuse([...dataListTemp], {
        keys: searchFlags,
        isCaseSensitive: false,
      });

      let res = fuse.search(e.target.value);

      res = res.map((v) => {
        return v.item;
      });

      // console.log(res);

      if (res.length) stateUpdator([...res]);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Form.Group className="mb-3">
        <div className="input-group mb-3">
          <span className="input-group-text bg-white" id="basic-addon2">
            <i className="bi bi-search"></i>
          </span>
          <input
            type="text"
            name="searchv"
            onKeyUp={handleSearchBarAction}
            className="form-control"
            placeholder={`Search by ${placeholders?.map((v) => v)} ...`}
            aria-label="search-units-mgr"
            aria-describedby="search-units-mgr"
          />
        </div>
      </Form.Group>
    </>
  );
}
